import { Box, Container, Heading, SimpleGrid, Stack } from '@chakra-ui/react';
import Image from 'next/image';
import React, { ReactNode } from 'react';

import { Blocks } from '@/services/after_sales/after-sales.service';
import { getImageLink } from '@/services/link.service';
import { directusImageLoader } from '@/utils/loaders';

import Styles from './AfterSales.module.scss';

type SimpleGridComponentProps = {
  className?: string;
  children: ReactNode;
  columns?: number[];
  alignItems?: string[];
  maxW?: string[];
  width?: string[];
  marginX?: string[];
};

type StackComponentProps = {
  className?: string;
  children: ReactNode;
  paddingY?: { [key: string]: string };
  paddingX?: { [key: string]: string };
  order?: { [key: string]: string };
  alignContent?: string;
};

const SimpleGridComponent = ({
  className,
  children,
  columns = [1, 1, 1, 2],
  alignItems = ['center'],
}: SimpleGridComponentProps) => {
  return (
    <SimpleGrid className={className} columns={columns} alignItems={alignItems}>
      {children}
    </SimpleGrid>
  );
};

const StackComponent = ({
  className,
  children,
  paddingY = { base: '10', md: '10', lg: '16' },
  paddingX = { base: '10', md: '6', lg: '16' },
  order = undefined,
  alignContent = 'center',
}: StackComponentProps) => {
  return (
    <Stack
      className={className}
      paddingY={paddingY}
      paddingX={paddingX}
      order={order}
      alignContent={alignContent}
    >
      {children}
    </Stack>
  );
};

type ImageComponentProps = {
  src: string;
  className: string | undefined;
  width?: number;
  height?: number;
  objectFit?: string | undefined;
  alt?: string;
};

const ImageComponent = ({
  src,
  className,
  width = 640,
  height = 420,
  objectFit = 'cover',
  alt = '',
}: ImageComponentProps) => {
  return (
    <Image
      src={src}
      loader={directusImageLoader}
      className={className}
      width={width}
      height={height}
      objectFit={objectFit}
      alt={alt}
    />
  );
};

export const AboutAfterSales = ({ blocks }: { blocks: Blocks[] }) => {
  return (
    <Container
      maxW={1280}
      width={'100%'}
      marginX={'auto'}
      paddingY={{ base: 0, md: 20 }}
      paddingX={0}
      className={Styles.afterSalesWrapper}
    >
      {blocks?.map((block, i) => (
        <SimpleGridComponent className={Styles.serviceBlockContent} key={i}>
          <Box
            className={`${Styles.serviceImgBlock} ${Styles.desktopImage}`}
            order={i % 2 === 1 ? { base: '2', lg: '1' } : {}}
          >
            <ImageComponent
              src={block?.image ? getImageLink(block?.image ?? '') + '' : ''}
              className={Styles.serviceImage}
              alt={'Service Image'}
            />
          </Box>
          <StackComponent className={Styles.serviceBlockDetails}>
            <Box className={Styles.headingElement}>
              <Heading
                as="h4"
                className={Styles.titleMd}
                marginBottom={{ base: 4, md: 5 }}
              >
                {block?.title}
              </Heading>
              <div
                className={Styles.titleText}
                dangerouslySetInnerHTML={{ __html: block?.text }}
              ></div>
            </Box>
          </StackComponent>
          <Box className={`${Styles.serviceImgBlock} ${Styles.mobileImage}`}>
            <ImageComponent
              src={block?.image ? getImageLink(block?.image ?? '') + '' : ''}
              className={Styles.serviceImage}
              alt={'Service Image'}
            />
          </Box>
        </SimpleGridComponent>
      ))}
    </Container>
  );
};
